(() => {
  const selector = 'swiper-container[data-lazy-swiper][init="false"]';

  const initialize = (swiper) => {
    customElements.whenDefined('swiper-container').then(() => {
      if (!swiper.isConnected || swiper.getAttribute('init') !== 'false') return;
      swiper.removeAttribute('init');
      swiper.initialize();
    });
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initialize(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;

  const register = (root) => {
    root.querySelectorAll(selector).forEach((swiper) => {
      if (observer) observer.observe(swiper);
      else initialize(swiper);
    });
  };

  register(document);

  document.addEventListener('shopify:section:load', (event) => {
    register(event.target);
  });
})();
